import React from "react";
import { useFormik } from "formik";

import { ITemp } from "../users-table";
import endpoints from "../../../../api/endpoints";
import usePutApi from "../../../../hooks/use-put-api";
import parseNumber from "../../../../utils/parse-number";
import { showErrorToast, showSuccessToast } from "src/utils/toast";
import { useSyncGlobalPageLoader } from "../../../../contexts/global-page-loader-context";
import ExposureLimitSchema, { IExposureLimitSchema } from "./schema/exposure-limit.schema";

interface Props {
  openModal: boolean;
  toggleModal: () => void;
  rowData: ITemp;
  parentUserId: string;
}

const ExposureLimitModal: React.FC<Props> = ({ openModal, toggleModal, rowData, parentUserId }) => {

  const { values, errors, handleChange, handleSubmit, handleBlur, resetForm } = useFormik({
    initialValues: {
      new_limit: 0,
      transaction_password: "",
      member_operation_type: "exposure-limit",
    },
    onSubmit: (formValues) => {
      handleExposureLimitSubmit(formValues);
    },
    validationSchema: ExposureLimitSchema,
  });

  const { putData, loading: putLoading } = usePutApi(endpoints.member.operation(rowData.id), [
    endpoints.member.getMember(parentUserId),
    endpoints.member.fetchDownLineList(parentUserId, 25, 0, "active"),
    endpoints.member.fetchDownLineList(parentUserId, 25, 0, "inactive"),
    endpoints.member.fetchDownLineList(parentUserId, 25, 0, "both"),
  ]);

  useSyncGlobalPageLoader(putLoading);

  const handleExposureLimitSubmit = async (submitData: IExposureLimitSchema) => {
    try {
      await putData({
        ...submitData,
        new_limit: parseNumber({ type: "float", value: values.new_limit }),
      });
      showSuccessToast("Exposure limit updated successfully");
      toggleModal();
      resetForm();
    } catch (error: any) {
      const errorMessage = error?.data?.status_message;
      showErrorToast(errorMessage || "Someting Went Wrong");
      toggleModal();
      resetForm();
    }
  };

  if (!openModal) return null;

  return (
    <>
    {/* style={{ position: "absolute", zIndex: 1040 }} */}
      <div
        role="dialog"
        className="modal fade show"
        aria-modal="true"
        style={{ display: "block" }}
        onMouseDown={(event) => {
          if (event.target === event.currentTarget) {
            toggleModal();
          }
        }}
      >
        <div className="modal-dialog modal-lg">
          <span />
          <div className="modal-content" style={{ marginTop: "60px" }}>
            <header className="modal-header">
              <h5 className="modal-title text-dark">Exposure Limit</h5>
              <button type="button" data-dismiss="modal" className="close text-white" onClick={toggleModal}>
                &times;
              </button>
            </header>
            <div className="modal-body credit-mdl">
              <form method="post" onSubmit={handleSubmit}>
                <div className="form-group row">
                  <label className="col-form-label col-4" htmlFor="exposureOldLimit">Old Limit</label>
                  <div className="col-8">
                    <input
                      id="exposureOldLimit"
                      placeholder="Old Credit"
                      type="text"
                      readOnly
                      value={rowData.exposure_limit}
                      className="form-control txt-right"
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-form-label col-4" htmlFor="exposureNewLimit">New Limit</label>
                  <div className="col-8">
                    <input
                      id="exposureNewLimit"
                      type="number"
                      name="new_limit"
                      className={`form-control txt-right ${errors.new_limit ? "is-invalid" : ""}`}
                      value={values.new_limit !== 0 ? values.new_limit : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-form-label col-4" htmlFor="exposureTransactionPassword">Transaction Password</label>
                  <div className="col-8 form-group-feedback form-group-feedback-right">
                    <input
                      id="exposureTransactionPassword"
                      name="transaction_password"
                      type="password"
                      className={`form-control ${errors.transaction_password ? "is-invalid" : ""}`}
                      value={values.transaction_password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-12 text-right">
                    <button type="button" className="btn btn-back" onClick={toggleModal}>
                      <i className="fas fa-undo mr-1" />
                      Back
                    </button>{" "}
                    <button type="submit" className="btn btn-primary">
                      Submit
                      <i className="fas fa-sign-in-alt ml-1" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <span />
        </div>
      </div>
      <div
        className="modal-backdrop"
        role="button"
        tabIndex={0}
        aria-label="Close exposure limit modal"
        onClick={toggleModal}
      />
    </>
  );
};

export default ExposureLimitModal;
